<template>
  <div>
    <LoadingButton :loading="loading" @click="auth_gmail" v-if='!profile.sending_email || !profile.sending_email.credentials'><i class="fab fa-google"></i> Connect gmail</LoadingButton>
    <p v-else>{{profile.sending_email.email}} connected</p>
  </div>
</template>

<script>
import { db } from '@/main.js'
import api from '@/lib/api.js'

export default {
  name: 'AuthGmail',
  props: ['profile'],
  data() {
    return {
      loading: false
    }
  },
  methods: {
    async auth_gmail() {
      this.loading = true
      let gapi = await this.$getGapiClient()

      const auth = await gapi.auth2.getAuthInstance()

      let offlineAccessExchangeCode = await auth.grantOfflineAccess({'access_type': 'offline', 'redirect_uri': 'postmessage', 'approval_prompt': 'force'})

      console.log(auth.currentUser.get())
      console.log(auth.currentUser.get().getBasicProfile())

      let email = auth.currentUser.get().getBasicProfile().getEmail()
      let name = auth.currentUser.get().getBasicProfile().getName()

      let sending_email_doc = await db.collection('team').doc(this.profile.team.id).collection('email').doc()
      await sending_email_doc.set({email: email, created: new Date(), updated: new Date(), status: 'enabled', name: name, user: db.collection('user').doc(this.profile.id)})
      await db.collection('user').doc(this.profile.id).update({updated: new Date(), sending_email: sending_email_doc})

      let result = await api.add_token_to_user(offlineAccessExchangeCode.code)
      this.loading = false

      if (!result.data.success) {
        this.$swal({title: 'Failed to connect', text: "Unable to connect gmail, please contact us.", icon: 'warning'})
      }
    },
  }
}
</script>

<style scoped>

</style>
